




import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { store } from '../../store/edit';

export default Vue.extend({
	name: 'OzakazkaSmluvniPartnerTypSelect',
	props: {
		storeUri: { type: String, default: null },
	},
	computed: {
		...genVuexComputeds(store),
	},
	// LP/TODO: Odkomentovat jakmile bude hotovy BE + pridat @update:value, actions, doplnit chovani a zavislosti dle DMS2
	// methods: {
	// 	...mapActions(DMS_MODULE, {
	// 		smluvniPartnerTypChange: types.actions.SMLUVNI_PARTNER_TYP_CHANGE,
	// 	}),
	// },
});
